"use client";

import { HeaderDropdownType } from "@faire/deprecated-retailer-visitor-shared/components/HeaderPriorityRenderer/useIsHeaderDropdownVisible";
import { createContextStore } from "@faire/web/ui/hooks/ContextStore";

type HeaderPriorityStore = {
  isNotificationPreviewVisible: boolean;
  isHeaderDropdownVisibleMap: Record<keyof typeof HeaderDropdownType, boolean>;
};

/**
 * Context store to keep track of reactive interactions on the top header navigation
 */
const { useStore: useHeaderPriorityStore, Provider: HeaderPriorityProvider } =
  createContextStore<HeaderPriorityStore>(
    {
      isNotificationPreviewVisible: false,
      isHeaderDropdownVisibleMap: {
        ACCOUNT: false,
        NOTIFICATIONS: false,
        CATEGORIES: false,
        LANGUAGE_SELECTOR: false,
      },
    },
    { name: "HeaderPriorityStore" }
  );

export { useHeaderPriorityStore, HeaderPriorityProvider };
